module.exports = __webpack_public_path__ + "img/icon4.28811db4.png";